module.exports = __webpack_public_path__ + "static/gallery43-350d7a3da8a6d7a7819402cbe128c11a.png";